<template lang="pug">
  v-layout.mt-2(row wrap)
    v-flex(md12)
      h4 TICKET AGREGADOS 
      v-data-table.elevation-1(:headers='headers' :items='saleTickets' hide-actions='')
        template(slot='items' slot-scope='props')
          td {{payer}}{{ props.item.id }}
          td.text-xs-left {{ props.item.sale_type }}
          td.text-xs-left ${{ props.item.ticket_total | mixThousandSeparatorFormat }}
          td.justify-center.layout.px-0
            v-tooltip(bottom)
              v-btn.mx-0(icon='' @click='deleteItem(props.item)' slot="activator")
                v-icon(color='grey') close
              span Descartar Ticket 
</template>

<script>
/* vuex */
import {mapState, mapActions} from 'vuex'
/* mixins */
import TextFormatting from '@/mixins/reusable_mixins/TextFormatting'
export default {
  name: 'multiple-ticket-selected',
  // props: {},
  data: function(){
    return {
      headers: [
        {
          text: 'Ticket',
          align: 'left',
          sortable: false,
          value: 'id'
        },
        { text: 'Tipo Venta', value: 'sale_type',sortable: false, },
        { text: '($)Monto', value: 'ticket_total' },
        { text: 'Acciones', value: 'id', sortable: false }
      ],
    }
  },
  computed: {
    ...mapState('CashDeskModule', {
        multipleSaleTicket : 'multipleSaleTicket',
        payer: 'payer',
    }),
    saleTickets(){
      if( this.multipleSaleTicket.length >0  ){
        return this.multipleSaleTicket.map(sale=>{
          sale.sale_type = (sale.pos_sale_type_id === 1) ? 'Boleta' : 'Factura' 
          return sale
        })
      } 
      else{
        return []
      }
    }
  },
  methods: {
    // -- UI Modification
    deleteItem(ticket){
      this.deleteMultipleSaleTicket(ticket)
      this.$emit('deleteMultipleSaleTicket',ticket)
    },
    // -- Data fetching
    // -- Data handling and transformations
    // -- Validations and Error handling
    // -- Other functions
    // -- Vuex mappings
    ...mapActions('CashDeskModule', {
          deleteMultipleSaleTicket : 'deleteMultipleSaleTicket'
        }),
  },
  // watch: {},
  // components: {},
  mixins: [TextFormatting],
  // filters: {},
  // -- Lifecycle Methods
  // -- End Lifecycle Methods
}
</script>

<style lang="scss">
  
</style>